import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Link,
  Grid,
  AppBar,
  Toolbar,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Checkbox } from "@mui/material";
import { useAuth } from "./AuthContext";
import backgroundImage from "../src/sitemap_bg.webp";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [apiError, setApiError] = useState(""); // State to store API error
  const [rememberMe, setRememberMe] = useState(false);

  const { setToken } = useAuth();
  const navigate = useNavigate();

  const Url = "https://aihumanizer.pranathiss.com/qxbox";

  const services = [
    { name: "Sitemap Generator", url: "https://aihumanizer.pranathiss.com/" },
    { name: "AI Humanizer", url: "https://aihumanizer.pranathiss.com/qxbox/humanizer/" },
    { name: "ScanX", url: "https://scanx.pranathiss.com/" },
    { name: "SEO Agent", url: "http://52.200.93.236:86/" },
    { name: "Avatar Chatbots", url: "https://app.avatarchatbots.ai/" },
    { name: "AI News Anchor", url: "https://tv.pranathiss.com/" },
    { name: "AI Podcast Generator", url: "http://103.211.39.22:8001/" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = true;

    // Reset errors
    setUsernameError("");
    setPasswordError("");
    setApiError(""); // Clear previous API error

    // Validate username
    if (!username.trim()) {
      setUsernameError("Username is empty");
      valid = false;
    }

    // Validate password
    if (!password.trim()) {
      setPasswordError("Password is empty");
      valid = false;
    }

    // If validation fails, stop submission
    if (!valid) return;

    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    try {
      const response = await axios.post(`${Url}/login/`, formData);
      const { token } = response.data;

      if (token) {
        setToken(token);
        console.log("Token set in context:", token);
        navigate("/extra");
      }
    } catch (error) {
      // Handle API errors
      if (error.response && error.response.data && error.response.data.error) {
        setApiError(error.response.data.error); // Extract error message from API response
      } else {
        console.error("Unexpected error:", error);
      }
    }
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header with Service Links */}
      <AppBar position="static" sx={{ backgroundColor: "#000075" }}>
        <Toolbar sx={{ justifyContent: "center", flexWrap: "wrap", padding: "10px 20px" }}>
          {services.map((service, index) => (
            <Link
              key={index}
              href={service.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "white",
                textDecoration: "none",
                margin: "5px 15px",
                fontSize: "14px",
                fontWeight: "500",
                "&:hover": {
                  textDecoration: "underline",
                  color: "#ffeb3b",
                },
              }}
            >
              {service.name}
            </Link>
          ))}
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Grid container sx={{ flex: 1 }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: "#000075",
            color: "white",
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
        <Typography
          variant="h5"
          component="h1"
          gutterBottom
          align="left"
          sx={{
            fontSize: "46px",
            color: "#ffffff",
            marginTop: "122px",
            marginLeft: "54px",
          }}
        >
          Sitemap Generator
        </Typography>
        <Box
          component="p"
          sx={{
            fontSize: "16px",
            color: "#ffffff",
            marginLeft: "54px",
            width: "80%",
          }}
        >
          Log in to streamline your site’s structure. Organize and generate
          sitemaps effortlessly.
        </Box>
      </Grid>

      {/* Login Box Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Paper
          sx={{ padding: 4, width: "55%", maxWidth: "100%", boxShadow: "none" }}
        >
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            align="left"
            sx={{ fontSize: "36px", color: " #000075" }}
          >
            Sitemap Generator Login
          </Typography>
         
          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              variant="outlined"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              error={!!usernameError}
              helperText={usernameError}
              sx={{ marginY: 2 }}
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!passwordError}
              helperText={passwordError}
              sx={{ marginY: 2, marginBottom: "10px" }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  color="primary"
                />
              }
              label="Remember me"
              sx={{ marginY: 0, marginBottom: "10px" }}
            />

{apiError && ( // Show API error if it exists
            <Typography
              variant="body2"
              color="error"
              sx={{ marginBottom: 2, textAlign: "center" }}
            >
              {apiError}
            </Typography>
          )}

            <Box sx={{ marginY: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  backgroundColor: "#000075",
                  padding: "6px",
                  fontSize: "16px",
                }}
              >
                Login
              </Button>
            </Box>

            <Box sx={{ textAlign: "center", marginTop: 4 }}>
              <Typography variant="body2" sx={{ fontSize: "18px" }}>
                Don't have an account?{" "}
                <Link
                  component="button"
                  onClick={() => navigate("/register")}
                  variant="body2"
                  sx={{ fontSize: "18px", color: "#000075" }}
                >
                  Signup
                </Link>
              </Typography>
            </Box>
          </form>
        </Paper>
      </Grid>
    </Grid>
    </Box>
  );
};

export default Login;
